export default {
  title: '主页',
  oldVersion: '返回旧版',
  myConfig: '我的配置',
  myConfig2: '我的配置',
  deviceCard: {
    deviceOverviewButton: '设备概况',
    newFirmwareButton: '新固件',
    productDevice: '产品/设备',
    deviceInformation: '设备信息',
    clickToEnter: '点击进入',
  },
  emptyState: {
    webSupportEmpty: '推荐在以下浏览器中使用网页驱动配置产品硬件：',
    webUnsupportEmpty: '暂不支持使用等其他浏览器：',
    webSupporting: '网页驱动支持以下产品型号，更多型号持续更新中',
    webSupportListBtn: '点击查看完整支持列表',
    clientEmpty: '未检测到设备，请重新连接或在右上角 [设置 > 接收器配对 > 进行配对识别]',
    connectButton: '连接设备',
    notFoundConfig: '未识别到设备，暂无配置文件',
    notFoundConfig2: '当前操作的设备没有配置功能',
    permissionTip1:
      '点击连接设备，如未看到授权框，请检查当前站点是否被当前浏览器限制了相关权限，可在当前浏览器设置中搜索"弹出式窗口和重定向"或者"弹出窗口和重定向"',
    permissionTip2:
      '(不同的浏览器可能搜索的名称会有所差异，请以当前浏览器的搜索名称为准)，并将当前网址加入允许列表后刷新重试',
  },
  config: {
    new: '新配置',
    card: {
      current: '当前',
      defaultName: '出厂配置',
      userDefaultName: '用户配置',
      untitled: '未命名',
      uploadText: '上传当前配置到个人中心备份',
      downloadText: '下载云端配置覆盖当前配置',
      notLoggedInUpload: '需要登录个人中心后才可上传',
      notLoggedInDownload: '需要登录个人中心后才可下载',
      delete: '删除配置',
      edit: '修改名称',
      defaultOnboard: '板载配置',
      defaultOnboard1: '板载配置1',
      defaultOnboard2: '板载配置2',
      defaultOnboard3: '板载配置3',
    },
    uploadDialog: {
      title: '上传当前配置文件',
      deviceModelLabel: '设备型号',
      deviceModelInput: '请输入设备型号',
      configNameLabel: '配置名称',
      configNameInput: '请输入配置名称',
    },
    uploadingDialog: {
      text: '正在上传当前配置文件到云端备份',
    },
    downloadingDialog: {
      text: '正在下载云端文件覆盖当前配置文件',
    },
    configListDialog: {
      title: '配置文件列表',
      deleteConfirmText: '删除后无法恢复，需要重新添加',
      footerButton: '下载覆盖',
    },
    deleteDialog: {
      title: '删除配置文件',
      confirmText: '确认删除当前使用的配置文件？删除后无法恢复，如需使用，请重新创建',
      confirmText2:
        '确认删除当前使用的配置文件？删除后将自动切换至上一个配置文件；删除后无法恢复，如需使用，请重新创建',
    },
    renameDialog: {
      title: '重命名',
      input: '请输入名称',
      overLimitTip: '名称长度超出限制',
    },
    gameApp: {
      title: '游戏与应用',
      addButton: '添加应用',
      emptyText: '待添加',
      appEmptyConfigText: '需将所需产品设备的配置文件添加进应用中才可生效',
      selectFilePicker: {
        title: '选择游戏或应用',
        filterName: '可执行文件',
        unknownFile: '未知应用',
      },
      deleteDialog: {
        title: '删除应用',
        description: '确认删除该应用吗？删除后无法恢复，需要重新添加',
      },
      detailDialog: {
        title: '应用详情',
      },
    },
  },
  newVersion: {
    title: '新版本',
    description: 'A HUB 又有新版本啦！',
    latestVersion: '最新版本',
    updateButton: '立即更新',
  },
  user: {
    logIn: '去登录',
    login: '登录',
    register: '注册',
    avatarAlt: '用户头像',
    nickname: '昵称',
    username: '账号',
    email: '邮箱',
    bindEmail: '绑定邮箱',
    bindWechat: '绑定微信',
    logout: '退出登录',
    changePassword: '修改密码',
    backLoginButton: '返回登录',
    usernamePlaceholder: '账号',
    emailPlaceholder: '邮箱',
    emailPlaceholder2: '请输入邮箱',
    passwordPlaceholder: '密码',
    passwordPlaceholder2: '请输入密码',
    oldPasswordPlaceholder: '原密码',
    newPasswordPlaceholder: '新密码',
    confirmNewPasswordPlaceholder: '确认新密码',
    captchaPlaceholder: '输入验证码',
    loginTab: {
      account: '账号登录',
      scan: '扫码登录',
    },
    registerTab: {
      account: '账号注册',
      scan: '扫码注册',
    },
    validate: {
      email: '请输入邮箱',
      emailFirst: '请先输入邮箱',
      emailValid: '请输入正确的邮箱',
      emailValidFirst: '请先输入正确的邮箱格式',
      captcha: '请输入验证码',
      captchaFailed: '验证码验证失败',
      captchaError: '验证码出错',
      oldPassword: '请输入原密码',
      newPassword: '请输入新密码',
      minPassword: '密码长度不能少于6位',
      maxPassword: '密码长度不能超过20位',
      username: '请输入账号',
      usernameValid: '至少6个字符，不允许空格、下划线、中文',
      password: '请输入密码',
      confirmPassword: '请确认密码',
      passwordValid: '6-20个字符，允许大小写字母/数字/!?＠#¥%&*()，不允许空格、中文等',
      passwordNotMatch: '密码不一致',
      passwordNotMatch2: '两次输入的密码不一致',
    },
    loginForm: {
      scanText: '使用微信扫一扫进行登录绑定',
      loginSuccessful: '登录成功',
      loginFailed: '登录失败',
      forget: '忘记密码',
      login: '立即登录',
    },
    registerForm: {
      confirmPasswordPlaceholder: '确认密码',
      registerSuccessful: '注册成功',
      registerFailed: '注册失败',
      register: '立即注册',
    },
    forgotPasswordForm: {
      title: '忘记密码',
      sendCaptcha: '发送验证码',
      sendCaptchaSuccessful: '已发送验证码',
      sendCaptchaFailed: '发送验证码失败',
      resetPasswordSuccessful: '重置密码成功，请重新登录',
    },
    bindAccountDialog: {
      title: '绑定原账号',
      success: '绑定账号成功',
    },
    bindWechatDialog: {
      title: '绑定微信号',
      titie: '绑定微信号',
      description: '使用微信扫一扫进行登录绑定',
      successToast: '绑定微信成功',
      error: '解析消息失败',
    },
    changePasswordDialog: {
      title: '修改密码',
      successToast: '修改密码成功',
    },
  },
  overview: {
    baseData: {
      title: '基础',
      model: '型号',
      currentConfig: '当前配置',
      connectionType: '连接方式',
      firmwareVersion: '固件版本',
      receiverVersion: '接收器版本',
      wired: '有线',
      wireless: '无线',
      reportRate: '回报率',
      sleepTime: '休眠时间',
      minutes: '分钟',
    },
    cfgData: {
      title: '参数',
      reportRate: '回报率',
      sensorMode: '性能模式',
      communicationProtocol: '通讯协议',
      keyScanRate: '按键扫描率',
      wirelessRF: '无线射频',
      motionSync: '移动同步',
      linearCorrection: '直线修正',
      rippleCorrection: '波纹修正',
      silentHeight: '光学引擎静默高度',
      keyDebounce: '按下去抖延迟',
      keyReleaseDebounce: '抬起去抖延迟',
      glassTracking: '玻璃追踪技术',
      sensorAngle: '传感器角度',
      pointerSpeed: '指针速度',
      wheelSpeed: '滚轮速度',
      sleepTime: '休眠时间',
      // 枚举值
      protocolTurbo: '高效协议turbo',
      protocolInitial: '初始协议',
      rfFull: '满格射频',
      rfSmart: '智能调节',
      on: '开启',
      off: '关闭',
      sensorModeOffice: '办公模式',
      sensorModeBalanced: '均衡模式',
      sensorModePower: '火力模式',
      sensorModeHyper: '超核模式',
      sensorModeCompetition: '竞技超核模式',
      sensorModeRampage: '狂暴竞技模式',
      wheelScroll: '滚动',
      wheelLine: '行',
      wheelPage: '滚动整页',
      minutes: '分钟',
      noSleep: '不休眠',
    },
    dpiData: {
      title: 'DPI设置',
      gearCount: '档位数',
      currentGear: '当前档位',
    },
    keyRemapData: {
      title: '改键',
    },
    rtData: {
      title: '按键触发',
      triggerTravel: '按键触发行程',
      rapidTrigger: '按键RT行程',
      vibration: '振动反馈',
      sound: '音效',
      volume: '音量',
      leftValue: '左{value}',
      rightValue: '右{value}',
      disabledValue: '（关闭）',
      feedbackValue: '{type}{value}',
      mechanicalSwitch: '类机械微动',
      opticalSwitch: '类光微动',
      electromagneticSwitch: '电磁微动',
    },
    screenDisplay: {
      title: '屏显',
      brightness: '屏幕亮度',
      imageCount: '屏显图片数量',
      imageUnit: '张',
    },
    keyboardLighting: {
      keyLight: '按键灯',
      sideLight: '侧灯',
      decorLight: '装饰灯',
      chargeLight: '充电灯',
      effectSetting: '灯效设置',
      brightness: '灯光亮度',
      speed: '灯光速度',
    },
    lightBand: {
      title: '灯带灯',
      lightMode: '灯光模式',
      chargeState: '充电状态显示',
      chargeLight: '显示充电灯',
      ambientLight: '显示氛围灯',
      speed: '灯光速度',
      brightness: '灯光亮度',
    },
    screenLogo: {
      title: '铭牌灯',
      lightMode: '灯光模式',
      chargeState: '充电状态显示',
      chargeLight: '显示充电灯',
      ambientLight: '显示氛围灯',
      speed: '灯光速度',
      brightness: '灯光亮度',
    },
    softwareData: {
      title: '软件',
      currentVersion: '当前版本',
      autoStart: '开机自启动',
      on: '开启',
      off: '关闭',
    },
  },
  // 游戏零售支持设备列表
  chinaGameSupportList: `
    <h3 class="text-l-medium text-black-white">雷柏VT二代全系列鼠标</h3>
      <div>
        <div>
          <h4 class="text-m-medium text-black-white">大手型：</h4>
          <p class="text-m-medium text-text-glass-default">
            VT7 MAX大师版 V2/VT7 AirMAX V2/VT7 MAX V2/VT7 PRO V2/VT7 V2/VT7 MAX/VT7；
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT3 MAX大师版 V2/VT3 AirMAX V2/VT3 MAX V2/VT3 PRO V2/VT3 V2/VT3 MAX/VT3；
          </p>
        </div>
        <div>
          <h4 class="text-m-medium text-black-white">中大手型：</h4>
          <p class="text-m-medium text-text-glass-default">
            VT9 MAX大师版 V2/VT9 AirMAX V2/VT9 MAX V2/VT9 PRO V2/VT9 V2/VT9 MAX/VT9；
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT2 MAX大师版 V2/VT2 AirMAX V2/VT2 MAX V2/VT2 V2/VT2MAX/VT2；
          </p>
        </div>
        <div>
          <h4 class="text-m-medium text-black-white">中手型：</h4>
          <p class="text-m-medium text-text-glass-default">VT6 MAX/VT6；</p>
          <p class="text-m-medium text-text-glass-default">
            VT4 MAX大师版 V2/VT4 AirMAX V2/VT4 MAX V2/VT4 V2；
          </p>
        </div>
        <div>
          <h4 class="text-m-medium text-black-white">中小手型：</h4>
          <p class="text-m-medium text-text-glass-default">
            VT9s MAX大师版 V2/VT9s AirMAX V2/VT9s MAX V2/VT9s PRO V2/VT9s V2；
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT7s MAX大师版 V2/VT7s AirMAX V2/VT7s MAX V2/VT7s PRO V2/VT7s V2；
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT3s MAX大师版 V2/VT3s AirMAX V2/VT3s MAX V2/VT3s PRO V2/VT3s V2/VT3s MAX大师版/VT3s AirMAX/VT3s
            MAX/VT3s；
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT2s MAX大师版 V2/VT2s AirMAX V2/VT2s MAX V2/VT2s V2；
          </p>
          <p class="text-m-medium text-text-glass-default">VT1 MAX/VT1；</p>
          <p class="text-m-medium text-text-glass-default">
            VT0 MAX大师版/VT0 AirMAX/VT0 MAX/VT0;
          </p>
        </div>
      </div>
    <h3 class="text-l-medium text-black-white">雷柏V系列游戏键盘：</h3>
    <p class="text-m-medium text-text-glass-default">V700DIY-98 长续航版/V700DIY-98/V700DIY-87/V700DIY-75;</p>
    <h3 class="text-l-medium text-black-white">雷柏无线游戏产品配件：</h3>
    <p class="text-m-medium text-text-glass-default">P5 PLUS/V5M;</p>
  `,
}
